import { type BlokProps, StoryblokComponentList } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { ColumnStoryblok } from "~/generated/sb/blok-types";
import styles from "./ColumnBlok.module.css";

export const ColumnBlok = ({ blok, preview }: BlokProps<ColumnStoryblok>) => {
	return (
		<BlokWrap
			as="div"
			editable={blok}
			className={clsx(styles.root)}
			data-position-y={blok.position_y}
			data-position-x={blok.position_x}
		>
			{blok.content && <StoryblokComponentList bloks={blok.content} preview={preview} />}
		</BlokWrap>
	);
};
